import * as style from './style.css';
import { ILayoutStat } from '../../../../types/layouts/layoutStat';
import { LinkButton, UIText1 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { useState, useCallback, useMemo } from 'react';
import { clsx } from 'clsx';
import { trackClickLayoutsSeoLink } from '../../../../utils/tracking/trackSeoLayoutPageLinkClick';
import { LayoutsLink } from './LayoutsLink';

interface ILayoutsLinksProps {
  layoutStats: ILayoutStat[];
  layoutsUrl: string;
  newbuildingId: number;
}

export const LayoutsLinksMobile = ({ layoutStats, layoutsUrl, newbuildingId }: ILayoutsLinksProps) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const onLinkClick = useCallback(
    () => trackClickLayoutsSeoLink({ newbuildingId, withRoomFilter: false }),
    [newbuildingId],
  );

  const onRoomLinkClick = useCallback(
    () => trackClickLayoutsSeoLink({ newbuildingId, withRoomFilter: true }),
    [newbuildingId],
  );

  const Icon = useMemo(() => (open ? IconActionChevronUpSmall16 : IconActionChevronDownSmall16), [open]);

  return (
    <div>
      <div className={style['container']}>
        <div className={style['control']} onClick={toggleOpen}>
          <UIText1 color="text-main-default">Все квартиры в этом ЖК</UIText1>
          <Icon color="icon-main-default" />
        </div>
      </div>
      <div className={clsx(style['links'], open && style['links--open'])}>
        {layoutStats &&
          layoutStats.map((layoutStat, index) => (
            <LayoutsLink {...layoutStat} onRoomLinkClick={onRoomLinkClick} key={index} />
          ))}
      </div>
      <LinkButton size="M" fullWidth href={layoutsUrl} target="_blank" onClick={onLinkClick}>
        Все планировки
      </LinkButton>
    </div>
  );
};
